import styled from 'styled-components'

/** `.review-lead` no desenho: corpo de texto apagado, sem margem. */
export const Lead = styled.p`
  margin: 0;

  font: var(--sl-text-body-font);
  color: var(--sl-fg-base-soft);
`

/**
 * `.review-actions` no desenho: fila à esquerda, embaixo da chamada, e não
 * alinhada à direita — a decisão acompanha o texto que a explica.
 */
export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: var(--sl-space-3);

  margin-top: var(--sl-space-4);
`

export const Reason = styled.p`
  margin: var(--sl-space-3) 0 0;

  font: var(--sl-text-body-font);
  color: var(--sl-fg-base-soft);
`
